export interface ComicChapter {
  id: string;
  title: string;
  updateDate: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  category: 'hanman' | 'riman' | 'guoman';
  tags: string[];
  rating: number;
  views: number;
  status: '连载中' | '已完结';
  description: string;
  latestChapter: string;
  updateDate: string;
  chapters: ComicChapter[];
}

export const categories = [
  { key: 'hanman', label: '韩漫', desc: '韩国漫画精选' },
  { key: 'riman', label: '日漫', desc: '日本漫画精选' },
  { key: 'guoman', label: '国漫', desc: '国产漫画精选' },
] as const;

export const comics: Comic[] = [
  {
    id: 'hanman-1',
    title: '女神降临',
    author: '喵喵',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20young%20woman%20with%20long%20dark%20hair%20and%20elegant%20features%2C%20clean%20line%20art%2C%20soft%20pastel%20colors%2C%20romance%20comic%20cover%20art%2C%20minimal%20background%20with%20subtle%20cherry%20blossom%20petals%2C%20Korean%20webtoon%20aesthetic&width=400&height=560&seq=comic-hanman-01&orientation=portrait',
    category: 'hanman',
    tags: ['恋爱', '校园', '逆袭'],
    rating: 9.5,
    views: 1280000,
    status: '连载中',
    description: '平凡女孩通过化妆逆袭成为校园女神，却意外卷入一段三角恋。当真实面貌被揭穿，爱情和友情将何去何从？这是一部关于成长、自信与真爱的青春校园漫画。',
    latestChapter: '第128话 新的开始',
    updateDate: '2026-08-04',
    chapters: [
      { id: 'ch-128', title: '第128话 新的开始', updateDate: '2026-08-04' },
      { id: 'ch-127', title: '第127话 告白之夜', updateDate: '2026-08-01' },
      { id: 'ch-126', title: '第126话 误会解开', updateDate: '2026-07-28' },
      { id: 'ch-125', title: '第125话 意外的相遇', updateDate: '2026-07-25' },
      { id: 'ch-124', title: '第124话 心跳加速', updateDate: '2026-07-22' },
    ],
  },
  {
    id: 'hanman-2',
    title: '我独自升级',
    author: 'Chugong / DUBU',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20action%20illustration%20of%20a%20powerful%20young%20man%20with%20dark%20armor%20and%20glowing%20eyes%2C%20fantasy%20hunter%20theme%2C%20dark%20atmospheric%20background%20with%20purple%20energy%20effects%2C%20clean%20detailed%20line%20art%2C%20webtoon%20cover%20style&width=400&height=560&seq=comic-hanman-02&orientation=portrait',
    category: 'hanman',
    tags: ['奇幻', '战斗', '升级'],
    rating: 9.8,
    views: 3560000,
    status: '已完结',
    description: '在一个充满怪物的世界里，最弱猎人成振宇在一次生死考验后获得了"系统"的力量，成为唯一能够不断升级的猎人。从此他的命运发生了翻天覆地的变化。',
    latestChapter: '第179话 终章',
    updateDate: '2026-07-30',
    chapters: [
      { id: 'ch-179', title: '第179话 终章', updateDate: '2026-07-30' },
      { id: 'ch-178', title: '第178话 最终决战', updateDate: '2026-07-27' },
      { id: 'ch-177', title: '第177话 觉醒之力', updateDate: '2026-07-24' },
      { id: 'ch-176', title: '第176话 命运对决', updateDate: '2026-07-21' },
      { id: 'ch-175', title: '第175话 最后的考验', updateDate: '2026-07-18' },
    ],
  },
  {
    id: 'hanman-3',
    title: '金秘书为何那样',
    author: '郑庆允',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20comedy%20illustration%20of%20a%20stylish%20office%20woman%20in%20a%20professional%20outfit%20and%20a%20handsome%20man%20in%20a%20suit%2C%20office%20setting%20background%2C%20soft%20warm%20colors%2C%20romantic%20comedy%20vibe%2C%20clean%20manhwa%20art%20style&width=400&height=560&seq=comic-hanman-03&orientation=portrait',
    category: 'hanman',
    tags: ['恋爱', '职场', '喜剧'],
    rating: 9.3,
    views: 2150000,
    status: '已完结',
    description: '完美的金秘书突然提出辞职，自恋狂老板李英俊这才意识到自己早已离不开她。一场啼笑皆非的追妻之旅就此展开，霸道总裁的深情告白令人心动。',
    latestChapter: '第98话 永远在一起',
    updateDate: '2026-07-15',
    chapters: [
      { id: 'ch-98', title: '第98话 永远在一起', updateDate: '2026-07-15' },
      { id: 'ch-97', title: '第97话 求婚', updateDate: '2026-07-12' },
      { id: 'ch-96', title: '第96话 真心话', updateDate: '2026-07-09' },
    ],
  },
  {
    id: 'hanman-4',
    title: '梨泰院Class',
    author: '赵光真',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20illustration%20of%20a%20determined%20young%20man%20standing%20in%20front%20of%20a%20restaurant%20at%20night%2C%20urban%20nightlife%20background%20with%20neon%20signs%2C%20dramatic%20lighting%2C%20warm%20and%20cool%20color%20contrast%2C%20modern%20Korean%20webtoon%20style&width=400&height=560&seq=comic-hanman-04&orientation=portrait',
    category: 'hanman',
    tags: ['创业', '复仇', '热血'],
    rating: 9.4,
    views: 1890000,
    status: '已完结',
    description: '不向权势低头的青年朴世路，在梨泰院开设了一家小酒馆，用自己的方式一步步实现复仇与梦想。这是一部关于信念、勇气和成长的励志故事。',
    latestChapter: '第112话 新的黎明',
    updateDate: '2026-06-20',
    chapters: [
      { id: 'ch-112', title: '第112话 新的黎明', updateDate: '2026-06-20' },
      { id: 'ch-111', title: '第111话 胜利的滋味', updateDate: '2026-06-17' },
      { id: 'ch-110', title: '第110话 最后的审判', updateDate: '2026-06-14' },
    ],
  },
  {
    id: 'riman-1',
    title: '咒术回战',
    author: '芥见下下',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20action%20illustration%20of%20a%20young%20sorcerer%20with%20spiky%20hair%20and%20a%20serious%20expression%2C%20dark%20supernatural%20energy%20surrounding%2C%20urban%20fantasy%20setting%20with%20cursed%20spirits%2C%20dynamic%20composition%2C%20bold%20line%20art%2C%20shonen%20manga%20cover%20style&width=400&height=560&seq=comic-riman-01&orientation=portrait',
    category: 'riman',
    tags: ['战斗', '奇幻', '校园'],
    rating: 9.7,
    views: 4520000,
    status: '连载中',
    description: '高中生虎杖悠仁吞下了诅咒之王的手指，从此踏上了咒术师的道路。与同伴们一起对抗诅咒，保护普通人的日常，一场关于生死与友情的战斗拉开序幕。',
    latestChapter: '第256话 宿命之战',
    updateDate: '2026-08-03',
    chapters: [
      { id: 'ch-256', title: '第256话 宿命之战', updateDate: '2026-08-03' },
      { id: 'ch-255', title: '第255话 领域展开', updateDate: '2026-07-31' },
      { id: 'ch-254', title: '第254话 终极奥义', updateDate: '2026-07-28' },
      { id: 'ch-253', title: '第253话 觉醒', updateDate: '2026-07-25' },
    ],
  },
  {
    id: 'riman-2',
    title: '间谍过家家',
    author: '远藤达哉',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20comedy%20illustration%20of%20a%20family%20of%20three%20including%20a%20man%20in%20a%20suit%2C%20a%20woman%20with%20red%20hair%2C%20and%20a%20cute%20little%20girl%20with%20pink%20hair%2C%20warm%20family%20setting%2C%20bright%20cheerful%20colors%2C%20spy%20comedy%20manga%20style&width=400&height=560&seq=comic-riman-02&orientation=portrait',
    category: 'riman',
    tags: ['喜剧', '家庭', '间谍'],
    rating: 9.6,
    views: 3980000,
    status: '连载中',
    description: '顶级间谍"黄昏"为了执行任务，临时组建了一个假家庭。然而他不知道的是，"妻子"是杀手，"女儿"是超能力者。这个奇妙的家庭日常充满了笑料与温情。',
    latestChapter: '第98话 家庭旅行',
    updateDate: '2026-08-02',
    chapters: [
      { id: 'ch-98', title: '第98话 家庭旅行', updateDate: '2026-08-02' },
      { id: 'ch-97', title: '第97话 女儿的秘密', updateDate: '2026-07-30' },
      { id: 'ch-96', title: '第96话 危机来袭', updateDate: '2026-07-27' },
    ],
  },
  {
    id: 'riman-3',
    title: '进击的巨人',
    author: '谏山创',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20dark%20fantasy%20illustration%20of%20a%20soldier%20with%20vertical%20maneuvering%20gear%20facing%20a%20giant%20titan%2C%20dramatic%20epic%20scene%2C%20apocalyptic%20background%20with%20crumbling%20walls%2C%20intense%20action%2C%20bold%20dramatic%20shadows%2C%20manga%20cover%20art&width=400&height=560&seq=comic-riman-03&orientation=portrait',
    category: 'riman',
    tags: ['黑暗', '奇幻', '战斗'],
    rating: 9.9,
    views: 5670000,
    status: '已完结',
    description: '人类被巨人逼到了高墙之内苟且偷生。少年艾伦·耶格尔目睹母亲被巨人吞噬后，发誓要消灭所有巨人。然而墙外的真相远比想象中更加残酷。',
    latestChapter: '第139话 最终话',
    updateDate: '2026-05-10',
    chapters: [
      { id: 'ch-139', title: '第139话 最终话', updateDate: '2026-05-10' },
      { id: 'ch-138', title: '第138话 漫长的梦', updateDate: '2026-05-07' },
      { id: 'ch-137', title: '第137话 天地之战', updateDate: '2026-05-04' },
    ],
  },
  {
    id: 'riman-4',
    title: '葬送的芙莉莲',
    author: '山田钟人 / 阿部司',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20fantasy%20illustration%20of%20an%20elf%20mage%20girl%20with%20long%20white%20hair%2C%20holding%20a%20staff%2C%20traveling%20through%20a%20beautiful%20pastoral%20landscape%2C%20soft%20nostalgic%20atmosphere%2C%20gentle%20warm%20colors%2C%20emotional%20fantasy%20manga%20style&width=400&height=560&seq=comic-riman-04&orientation=portrait',
    category: 'riman',
    tags: ['奇幻', '冒险', '温情'],
    rating: 9.8,
    views: 2340000,
    status: '连载中',
    description: '打倒魔王后的勇者队伍中，精灵魔法使芙莉莲拥有漫长的寿命。当同伴们相继老去离世，她才开始真正理解人类的感情。这是一段追寻逝去时光的旅程。',
    latestChapter: '第128话 重逢之路',
    updateDate: '2026-08-01',
    chapters: [
      { id: 'ch-128', title: '第128话 重逢之路', updateDate: '2026-08-01' },
      { id: 'ch-127', title: '第127话 记忆之花', updateDate: '2026-07-29' },
      { id: 'ch-126', title: '第126话 远古魔法', updateDate: '2026-07-26' },
    ],
  },
  {
    id: 'guoman-1',
    title: '一人之下',
    author: '米二',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20supernatural%20martial%20arts%20illustration%20of%20a%20young%20man%20with%20traditional%20Chinese%20clothing%20and%20mysterious%20energy%20aura%2C%20urban%20fantasy%20setting%20with%20Chinese%20cultural%20elements%2C%20dynamic%20action%20pose%2C%20vibrant%20colors%2C%20Chinese%20comic%20art%20style&width=400&height=560&seq=comic-guoman-01&orientation=portrait',
    category: 'guoman',
    tags: ['奇幻', '异能', '搞笑'],
    rating: 9.5,
    views: 3450000,
    status: '连载中',
    description: '普通大学生张楚岚因爷爷的坟墓被盗，意外卷入了异人世界的纷争。在这个充满奇人异术的世界里，他逐渐揭开了自己身世的秘密，踏上了一条不平凡的道路。',
    latestChapter: '第620话 真相浮现',
    updateDate: '2026-08-04',
    chapters: [
      { id: 'ch-620', title: '第620话 真相浮现', updateDate: '2026-08-04' },
      { id: 'ch-619', title: '第619话 决战前夕', updateDate: '2026-08-01' },
      { id: 'ch-618', title: '第618话 古老传承', updateDate: '2026-07-29' },
      { id: 'ch-617', title: '第617话 异能对决', updateDate: '2026-07-26' },
      { id: 'ch-616', title: '第616话 身世之谜', updateDate: '2026-07-23' },
    ],
  },
  {
    id: 'guoman-2',
    title: '狐妖小红娘',
    author: '小新',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20fantasy%20romance%20illustration%20of%20a%20beautiful%20fox%20spirit%20girl%20with%20traditional%20Chinese%20red%20dress%20and%20flowing%20long%20hair%2C%20magical%20atmosphere%20with%20cherry%20blossom%20petals%2C%20ancient%20Chinese%20palace%20background%2C%20elegant%20romantic%20style&width=400&height=560&seq=comic-guoman-02&orientation=portrait',
    category: 'guoman',
    tags: ['恋爱', '仙侠', '奇幻'],
    rating: 9.4,
    views: 2870000,
    status: '连载中',
    description: '在一个人与妖共存的世界里，狐妖小红娘涂山苏苏为前世恋人牵线续缘。每一段跨越轮回的爱情故事都令人动容，而她自己也在成长中逐渐找到了真正的使命。',
    latestChapter: '第485话 前世今生',
    updateDate: '2026-08-02',
    chapters: [
      { id: 'ch-485', title: '第485话 前世今生', updateDate: '2026-08-02' },
      { id: 'ch-484', title: '第484话 缘定三生', updateDate: '2026-07-30' },
      { id: 'ch-483', title: '第483话 狐妖之力', updateDate: '2026-07-27' },
    ],
  },
  {
    id: 'guoman-3',
    title: '镖人',
    author: '许先哲',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20historical%20martial%20arts%20illustration%20of%20a%20rugged%20swordsman%20in%20ancient%20Chinese%20warrior%20attire%2C%20riding%20a%20horse%20through%20a%20desert%20landscape%2C%20dramatic%20dusty%20atmosphere%2C%20bold%20ink%20wash%20painting%20style%2C%20wuxia%20aesthetic&width=400&height=560&seq=comic-guoman-03&orientation=portrait',
    category: 'guoman',
    tags: ['武侠', '历史', '热血'],
    rating: 9.7,
    views: 1980000,
    status: '连载中',
    description: '隋末唐初，天下大乱。镖客刀马带着小七行走江湖，卷入了一场惊天阴谋。硬核的武侠画风，厚重历史感，被誉为"中国漫画的里程碑之作"。',
    latestChapter: '第112话 风起云涌',
    updateDate: '2026-07-28',
    chapters: [
      { id: 'ch-112', title: '第112话 风起云涌', updateDate: '2026-07-28' },
      { id: 'ch-111', title: '第111话 荒漠对决', updateDate: '2026-07-25' },
      { id: 'ch-110', title: '第110话 刀光剑影', updateDate: '2026-07-22' },
    ],
  },
  {
    id: 'guoman-4',
    title: '斗罗大陆',
    author: '唐家三少 / 穆逢春',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20fantasy%20cultivation%20illustration%20of%20a%20handsome%20young%20man%20with%20blue%20silver%20grass%20spirit%20ring%20energy%2C%20martial%20arts%20outfit%2C%20epic%20fantasy%20world%20background%20with%20magical%20creatures%2C%20vibrant%20colors%2C%20Chinese%20webcomic%20style&width=400&height=560&seq=comic-guoman-04&orientation=portrait',
    category: 'guoman',
    tags: ['玄幻', '热血', '成长'],
    rating: 9.3,
    views: 5120000,
    status: '连载中',
    description: '唐门外门弟子唐三偷学内门绝学被发现后跳崖明志，却意外穿越到了斗罗大陆。在这个武魂为尊的世界里，他凭借前世记忆和双生武魂，一步步走向巅峰。',
    latestChapter: '第358话 封号斗罗',
    updateDate: '2026-08-03',
    chapters: [
      { id: 'ch-358', title: '第358话 封号斗罗', updateDate: '2026-08-03' },
      { id: 'ch-357', title: '第357话 海神岛', updateDate: '2026-07-31' },
      { id: 'ch-356', title: '第356话 深海之战', updateDate: '2026-07-28' },
      { id: 'ch-355', title: '第355话 九节鱼龙兽', updateDate: '2026-07-25' },
    ],
  },
];

export const getComicsByCategory = (category: string): Comic[] => {
  return comics.filter((c) => c.category === category);
};

export const getComicById = (id: string): Comic | undefined => {
  return comics.find((c) => c.id === id);
};

export const getHotComics = (limit: number = 8): Comic[] => {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
};

export const getLatestComics = (limit: number = 10): Comic[] => {
  return [...comics].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, limit);
};

export const features = [
  {
    icon: 'ri-book-open-line',
    title: '海量漫画资源',
    desc: '涵盖韩漫、日漫、国漫三大品类，持续更新热门漫画，满足各种阅读口味。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '下拉式阅读体验',
    desc: '优化的下拉式滚动阅读模式，流畅自然的浏览体验，让阅读漫画更加轻松舒适。',
  },
  {
    icon: 'ri-price-tag-3-line',
    title: '完全免费',
    desc: '所有漫画资源完全免费，无需注册即可畅读，让每一位漫画爱好者都能享受阅读乐趣。',
  },
  {
    icon: 'ri-file-list-3-line',
    title: '分类清晰',
    desc: '韩漫、日漫、国漫分类明确，热门推荐精准，帮您快速找到想看的漫画作品。',
  },
];

export const stats = [
  { value: '10,000+', label: '漫画资源' },
  { value: '500万+', label: '月活跃读者' },
  { value: '99.9%', label: '好评率' },
  { value: '24h', label: '极速更新' },
];